import { Component, OnChanges, OnInit, RendererFactory2, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { UploadService } from 'src/app/_shared/services/upload.service';
import { ServicesService } from 'src/app/services/services.service';
import Swal from 'sweetalert2';
import { Category } from '../../interface';
import { getDirtyValues } from 'src/app/_shared/utils/form';
import { BUCKET_URL } from 'src/app/_shared/utils/constants';


@Component({
  selector: 'app-service-category-create',
  templateUrl: './service-category-create.component.html',
  styleUrls: ['./service-category-create.component.scss']
})
export class ServiceCategoryCreateComponent extends ModalComponent {
  private unsubscribe$ = new Subject();
  public serviceCategoryFormGroup: FormGroup;
  public uploadingImage: boolean;
  public category: Category;
  isLoading: boolean;
  constructor(
    renderFactory: RendererFactory2,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private uploadService: UploadService,
    private serviceService: ServicesService
  ) {
    super(renderFactory);
  }

  onInit(): void {
    this.createFormGroup();
    const { id } = this.route.snapshot.params;
    if (id && id != "new") {
      this.category = this.serviceService.getServiceCategoryById(id)

      if (this.category) {
        this.serviceCategoryFormGroup.patchValue(this.category);
        this.serviceCategoryFormGroup.controls.name.disable();
      }
      else {
        this.serviceService.getServiceCategories().subscribe(val => {
          this.category = val.find(val => val.id == id)
          this.serviceCategoryFormGroup.patchValue(this.category);
          this.serviceCategoryFormGroup.controls.name.disable();
        })
      }
    }

  }

  private createFormGroup() {
    this.serviceCategoryFormGroup = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]],
      icon: [],
      is_event: [false, [Validators.required]],
      published: [false, [Validators.required]],
    });
  }

  public get categoryFormControl() {
    return this.serviceCategoryFormGroup.controls;
  }

  close() {
    this.show = false;
    setTimeout(
      () => this.router.navigate(["."], { relativeTo: this.route.parent }),
      100
    );
  }

  public previewImage(
    event: any,
    control: AbstractControl,
  ) {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      this.uploadingImage = true;
      this.uploadService.upload(formData).subscribe(
        (res) => {
          this.uploadingImage = false;
          control.patchValue(res.image_url);
          control.markAsDirty()
        },
        (err) => {
          this.uploadingImage = false;
          let message = "Server error";
          if (err.status && err.status == 400) {
            message = err.error.message;
          }
          Swal.fire({
            title: "Image upload failed",
            text: message,
            type: "error",
            timer: 2000,
          });
        }
      );
    }
  }


  public onSubmit() {
    this.isLoading = true
    if (this.category) {
      const values = getDirtyValues(this.serviceCategoryFormGroup) as Category;
      this.serviceService.updateServiceCategory(this.category.id, values).subscribe(res => {
        this.isLoading = false
        Swal.fire({
          title: 'Category successfully updated',
          type: 'success',
          timer: 2000
        })
      }, err => {
        this.isLoading = false
        Swal.fire({
          title: "Error",
          text: err.error.message,
          type: "error",
          timer: 2000,
        });
      })
      return
    }
    this.serviceService.createServiceCategory(this.serviceCategoryFormGroup.value).subscribe(val => {
      this.close();
      this.isLoading = false
      Swal.fire({
        title: 'Category successfully created',
        type: 'success',
        timer: 2000
      })
    }, err => {
      this.isLoading = false
      Swal.fire({
        title: "Error",
        text: err.error.message,
        type: "error",
        timer: 2000,
      });
    })
  }

  get iconUrl() {
    if (this.category) {
      return this.category.icon || 'https://via.placeholder.com/150?text=admin.ezyagric.com'
    }
    return this.categoryFormControl.icon.value ? BUCKET_URL + this.categoryFormControl.icon.value : 'https://via.placeholder.com/150?text=admin.ezyagric.com'
  }

  onDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
